import { render, staticRenderFns } from "./adminSidemenu.vue?vue&type=template&id=45eebd78&"
import script from "./adminSidemenu.vue?vue&type=script&lang=js&"
export * from "./adminSidemenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports